"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var h=require("react"),v=require("react-lazyload"),m=require("@vfuk/core-base-props"),e=require("styled-components"),c=require("@vfuk/core-mixins");function o(s){return s&&s.__esModule?s:{default:s}}var l=o(h),w=o(v),a=o(e);const x=typeof a.default=="object"&&"default"in a.default?a.default.default:a.default,y=x.div(s=>{const t=s.theme.spacing.responsive[s.spacing];return e.css`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: -${t.sm/2}px;

    ${c.respondTo.md(e.css`
      margin: -${t.md/2}px;
    `)}

    ${c.respondTo.lg(e.css`
      margin: -${t.lg/2}px;
    `)}

    ${c.respondTo.xl(e.css`
      margin: -${t.xl/2}px;
    `)}

    ${s.verticalAlign==="center"&&e.css`
      align-items: center;
    `}

    ${s.verticalAlign==="stretch"&&e.css`
      align-items: stretch;
    `}

    ${s.verticalAlign==="bottom"&&e.css`
      align-items: flex-end;
    `}

    ${s.justify==="center"&&e.css`
      justify-content: center;
    `}

    ${s.justify==="right"&&e.css`
      justify-content: flex-end;
    `}
  `}),f=x.div(s=>{const t=s.theme.spacing.responsive[s.spacing];return e.css`
    margin: ${t.sm/2}px;

    ${c.respondTo.md(e.css`
      margin: ${t.md/2}px;
    `)}

    ${c.respondTo.lg(e.css`
      margin: ${t.lg/2}px;
    `)}

    ${c.respondTo.xl(e.css`
      margin: ${t.xl/2}px;
    `)}

    ${s.columns&&e.css`
      width: calc((100% / ${s.columns.sm}) - ${t.sm}px);

      ${c.respondTo.md(e.css`
        width: calc((100% / ${s.columns.sm}) - ${t.md}px);

        ${s.columns.md&&e.css`
          width: calc((100% / ${s.columns.md}) - ${t.md}px);
        `}
      `)}

      ${c.respondTo.lg(e.css`
        width: calc((100% / ${s.columns.sm}) - ${t.lg}px);

        ${s.columns.md&&e.css`
          width: calc((100% / ${s.columns.md}) - ${t.lg}px);
        `}

        ${s.columns.lg&&e.css`
          width: calc((100% / ${s.columns.lg}) - ${t.lg}px);
        `}
      `)}

      ${c.respondTo.xl(e.css`
        width: calc((100% / ${s.columns.sm}) - ${t.xl}px);

        ${s.columns.md&&e.css`
          width: calc((100% / ${s.columns.md}) - ${t.xl}px);
        `}

        ${s.columns.lg&&e.css`
          width: calc((100% / ${s.columns.lg}) - ${t.xl}px);
        `}

        ${s.columns.xl&&e.css`
          width: calc((100% / ${s.columns.xl}) - ${t.xl}px);
        `}
      `)}
    `}

    ${s.layout&&e.css`
      width: calc(((100% / 12) * ${s.layout.sm}) - ${t.sm}px);

      ${c.respondTo.md(e.css`
        width: calc(((100% / 12) * ${s.layout.sm}) - ${t.md}px);

        ${s.layout.md&&e.css`
          width: calc(((100% / 12) * ${s.layout.md}) - ${t.md}px);
        `}
      `)}

      ${c.respondTo.lg(e.css`
        width: calc(((100% / 12) * ${s.layout.sm}) - ${t.lg}px);

        ${s.layout.md&&e.css`
          width: calc(((100% / 12) * ${s.layout.md}) - ${t.lg}px);
        `}

        ${s.layout.lg&&e.css`
          width: calc(((100% / 12) * ${s.layout.lg}) - ${t.lg}px);
        `}
      `)}

      ${c.respondTo.xl(e.css`
        width: calc(((100% / 12) * ${s.layout.sm}) - ${t.xl}px);

        ${s.layout.md&&e.css`
          width: calc(((100% / 12) * ${s.layout.md}) - ${t.xl}px);
        `}

        ${s.layout.lg&&e.css`
          width: calc(((100% / 12) * ${s.layout.lg}) - ${t.xl}px);
        `}

        ${s.layout.xl&&e.css`
          width: calc(((100% / 12) * ${s.layout.xl}) - ${t.xl}px);
        `}
      `)}
    `}

    ${s.verticalAlign==="stretch"&&e.css`
      display: flex;

      & > * {
        flex-grow: 1;
      }
    `}
  `});var b=Object.freeze({__proto__:null,SimpleGrid:y,SimpleGridColumn:f}),j=Object.defineProperty,$=Object.getOwnPropertySymbols,_=Object.prototype.hasOwnProperty,S=Object.prototype.propertyIsEnumerable,g=(s,t,r)=>t in s?j(s,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):s[t]=r,i=(s,t)=>{for(var r in t||(t={}))_.call(t,r)&&g(s,r,t[r]);if($)for(var r of $(t))S.call(t,r)&&g(s,r,t[r]);return s};class n extends h.PureComponent{constructor(){super(...arguments),this.componentName="SimpleGrid",this.lazyLoadingProperties=typeof this.props.lazy=="object"&&this.props.lazy!==null?i({},this.props.lazy):null}getLayout(t){const r=this.props.layout,p={};return r&&Object.keys(r).forEach(d=>{const u=r[d];p[d]=u[t%u.length]}),p}get filteredChildren(){const t=[];return l.default.Children.forEach(this.props.children,r=>{r&&t.push(r)}),t}render(){return l.default.createElement(y,i({id:this.props.id,"data-component-name":this.componentName,"data-selector":m.getDataSelector(this.props.dataSelectorPrefix),justify:this.props.justify,spacing:this.props.spacing,verticalAlign:this.props.verticalAlign},this.props.dataAttributes),this.filteredChildren.map((t,r)=>l.default.createElement(f,{key:r,columns:this.props.columns,spacing:this.props.spacing,verticalAlign:this.props.verticalAlign,layout:this.getLayout(r),"data-selector":m.getDataSelector(this.props.dataSelectorPrefix,`column-${r}`)},this.props.lazy?l.default.createElement(w.default,i({},this.lazyLoadingProperties),t):t)))}}n.defaultProps={spacing:0,justify:"left"};exports.SimpleGrid=n;exports.SimpleGridStyles=b;exports.default=n;
//# sourceMappingURL=index.cjs.map
